import { gql } from '@apollo/client';

export const GET_USER_HIERARCHY = gql`
  query GetUserHierarchy($userId: String!) {
    getUserHierarchy(userId: $userId) {
      id
      name
      email
      userName
      contact
      isActive
      createdAt
      parentId
      invitedUsers {
        id
        name
        email
        userName
        contact
        isActive
        createdAt
        parentId
        invitedUsers {
          id
          name
          email
          userName
          contact
          isActive
          createdAt
          parentId
          invitedUsers {
            id
            name
            email
            userName
            contact
            isActive
            createdAt
            parentId
          }
        }
      }
    }
  }
`;

export const GET_TEAM_STATS = gql`
  query GetTeamStats($userId: String!) {
    getTeamStats(userId: $userId) {
      totalTeamSize
      directReferrals
      activeMembers
      totalEarnings
    }
  }
`;


export const GET_LEVEL_TREE = gql`
  query GetLevelTree($userId: String) {
    getLevelTree(userId: $userId) {
      success
      message
      currentUser {
        id
        name
        email
        userName
        contact
        joinDate
        level
        totalEarnings
        directReferrals
        totalDownline
        status
        parentId
        sponsor {
          id
          name
          userName
          contact
        }
        serviceProvider {
          id
          name
          userName
          contact
        }
        isAlive
      }
      levelData {
        id
        name
        email
        userName
        contact
        joinDate
        level
        totalEarnings
        directReferrals
        totalDownline
        status
        parentId
        package
        sponsor {
          id
          name
          userName
          contact
        }
        serviceProvider {
          id
          name
          userName
          contact
        }
        isAlive
      }
      stats {
        totalTeamSize
        directReferrals
        activeMembers
        teamEarnings
        maxLevel
      }
    }
  }
`;

export const GET_MY_TEAM = gql`
  query GetMyTeam($userId: String) {
    getMyTeam(userId: $userId) {
      success
      message
      currentUser {
        id
        name
        email
        userName
        contact
        joinDate
        level
        totalEarnings
        directReferrals
        totalDownline
        status
        parentId
        sponsor {
          id
          name
          userName
          contact
        }
        serviceProvider {
          id
          name
          userName
          contact
        }
        isAlive
      }
      levelData {
        id
        name
        email
        userName
        contact
        joinDate
        level
        totalEarnings
        directReferrals
        totalDownline
        status
        parentId
        package
        sponsor {
          id
          name
          userName
          contact
        }
        serviceProvider {
          id
          name
          userName
          contact
        }
        isAlive
      }
      stats {
        totalTeamSize
        directReferrals
        activeMembers
        teamEarnings
        maxLevel
      }
    }
  }
`;